import { render, staticRenderFns } from "./CreateParamScroll.vue?vue&type=template&id=83f84ca2"
import script from "./CreateParamScroll.vue?vue&type=script&lang=js"
export * from "./CreateParamScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports